import { render } from "./studioViewCourse.vue?vue&type=template&id=3a050338&scoped=true"
import script from "./studioViewCourse.vue?vue&type=script&lang=js"
export * from "./studioViewCourse.vue?vue&type=script&lang=js"

import "./studioViewCourse.vue?vue&type=style&index=0&id=3a050338&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a050338"]])

export default __exports__